export default __webpack_public_path__ + "static/media/ksivalue_main_mobile@2x.90cff8eb.jpg";